import httpClient, { createRequest } from './services/httpClient';
import UnauthorizedMiddleware from './services/middleware/unauthorizedMiddleware';
import FileUploadMiddleware from './services/middleware/fileUploadMiddleware';
import UndefinedErrorResponseMiddleware from './services/middleware/undefinedErrorResponseMiddleware';

export default httpClient;

export {
    createRequest,
    UnauthorizedMiddleware,
    FileUploadMiddleware,
    UndefinedErrorResponseMiddleware,
};
